<template>
  <div class="container start flex-center">
    <a href="https://www.sbn.de" title="Zur Startseite" class="sbn-logo">
      <img src="https://www.sbn.de/media/d4/d9/91/1636624996/SBN_Logo.png" />
      <span>Zurück</span>
    </a>
    
    <h1>Produktsuche – Wälzlager</h1>
    <p class="description">
      Finden Sie Ihr gewünschtes Wälzlager über unsere praktische Suchfunktion.<br />
    </p>

    <bearing-picker
      v-if="bearingPickerIsOpen"
      @update:list="updateBearingResultList"
      @close="closeBearingSelect"
      :isSearchMode="bearingPickerModeIsSearch"
      :searchResults="bearingResultList"
      :currentPage="bearingResultCurrentPage"
      :resultLength="bearingResultListLength"
      :isLoadingList="reloadingBearingList"
      :pageSize="bearingResultPageLength"
      :filterSeal="selectorSeal"
      :filterCategory="selectorCategories"
    />
    <div class="spin-wrapper" v-else>
      <span class="spinner">
        <svg
          version="1.1"
          id="e044922d-8653-4a01-a8bf-eb06d885328c"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 109.7 109.7"
          style="enable-background: new 0 0 109.7 109.7"
          xml:space="preserve"
        >
          <g>
            <circle class="st0" cx="86.2" cy="24.9" r="11.4" />
            <path
              class="st0"
              d="M108.2,42.2l-0.1-0.1c-0.5-1.9-1.4-3.6-2.8-5c-4.3-4.6-11.6-4.7-16.1-0.4c-3.1,2.9-4.3,7.3-3.1,11.3l0,0
              c3.7,17.2-7.2,34.2-24.5,38s-34.2-7.2-38-24.5s7.2-34.2,24.5-38c5.1-1.1,10.4-0.9,15.4,0.5l0.2,0.2l0,0l-0.2-0.2
              c6.1,1.6,12.4-2,14-8.1c1.6-6.1-2-12.4-8.1-14l0,0C40.2-6,10,11.1,2,40.3s9.2,59.4,38.4,67.4c29.2,8,59.4-9.2,67.4-38.4
              C110.1,60.5,110.3,51.2,108.2,42.2z"
            />
          </g>
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BearingPicker from "./components/BearingPicker.vue";

//find a get parameter
function getBearingID() {
  for (let getParam of location.search.substr(1).split("&")) {
    let [id, val] = getParam.split("=");
    if (id === "bearingID") {
      return decodeURIComponent(val);
    }
  }
  return false;
}

let instance = axios.create({
  baseURL: "https://www.sbn.de/store-api/",
  headers: {
    post: {
      "sw-access-key": "SWSCEADHUA-XEQP00935FS5GBW",
    },
  },
});

export default {
  name: "App",
  components: {
    BearingPicker,
  },

  data() {
    return {
      hasError: false,
      errorMessage: "",

      bearingPickerIsOpen: false,
      bearingPickerModeIsSearch: false,
      bearingSelectInner: [],
      bearingSelectOuter: [],
      bearingSelectWidth: [],
      bearingResultList: [],
      bearingResultListLength: 0,
      bearingResultCurrentPage: 0,
      bearingResultPageLength: 30,
      selectedBearing: null,
      reloadingBearingList: false,

      selectorSeal: {},
      selectorCategories: {},
    };
  },
  mounted() {
    //load dropdowns
    instance
      .post("/product", {
        includes: {
          product: [],
        },
        associations: {
          properties: {
            limit: 15,
          },
        },
        filter: [
          {
            type: "multi",
            operator: "and",
            queries: [
              {
                type: "equals",
                field: "active",
                value: true,
              },
              {
                type: "multi",
                operator: "or",
                queries: [
                  {
                    type: "contains",
                    field: "categoryTree",
                    value: "4ede08246d804633a2124884b523c5ae",
                  },
                  {
                    type: "contains",
                    field: "categoryTree",
                    value: "be0667df4ad14d6da566d8da242b7190",
                  }
                ]
              }
            ],
          },
        ],
        limit: 1,
        aggregations: [
          {
            name: "filter-dichtung",
            type: "terms",
            field:
              "customFields.yuniqProductProperty_dic_dichtung_alternativtext",
          },
          {
            name: "filter-artikelgruppe",
            type: "terms",
            field: "customFields.yuniqProductProperty_gruppe_artikelgruppe",
          },
        ],
      })
      .then((response) => {
        let data = response["data"];

        let categories = data.aggregations["filter-artikelgruppe"].buckets
          .map((b) => b.key)
          .sort((a, b) => a.localeCompare(b));
        let seals = data.aggregations["filter-dichtung"].buckets
          .map((b) => b.key)
          .sort((a, b) => a.localeCompare(b));

        seals.shift(); //remove the first element

        this.selectorSeal = {
          options: {},
          defaultOptionID: 0,
        };

        seals.forEach((option, index) => {
          this.selectorSeal.options[index] = {
            value: option,
            label: option,
            selectedLabel: option,
            isSelectable: true,
          };
        });

        this.selectorCategories = {
          options: {},
          defaultOptionID: 0,
        };
        
        categories.forEach((option, index) => {
          this.selectorCategories.options[index] = {
            value: option,
            label: option,
            selectedLabel: option,
            isSelectable: true,
          };
        });

        this.bearingPickerIsOpen = true;
      })
      .catch((e) => {
        console.log("ERROR: ");
        console.log(e);
      });

      this.updateBearingResultList({
        page: 1,
        sortField: 'name',
        sortDirection: 'ASC'
      });
  },
  methods: {
    updateBearingResultList: function (selectObject) {
      this.reloadingBearingList = true;

      let filter = [];

      let aggregations = [
        {
          name: "count",
          type: "count",
          field: "id",
        },
      ];

      let queries = [
        {
          type: "equals",
          field: "active",
          value: true,
        },
        {
          type: "multi",
          operator: "or",
          queries: [
            {
              type: "contains",
              field: "categoryTree",
              value: "4ede08246d804633a2124884b523c5ae",
            },
            {
              type: "contains",
              field: "categoryTree",
              value: "be0667df4ad14d6da566d8da242b7190",
            }
          ]
        }
      ];

      if ("descr" in selectObject) {
        queries.push({
          type: "contains",
          field: "name",
          value: selectObject.descr,
        });
      }

      if ("innerMin" in selectObject || "innerMax" in selectObject) {
        let queryParam = {};
        if ("innerMin" in selectObject) {
          queryParam.gte = Number.parseFloat(
            selectObject.innerMin.replace(",", ".")
          );
        }
        if ("innerMax" in selectObject) {
          queryParam.lte = Number.parseFloat(
            selectObject.innerMax.replace(",", ".")
          );
        }

        queries.push({
          type: "range",
          field: "customFields.yuniqProductProperty_virtuell_innen_d",
          parameters: queryParam,
        });
      }

      if ("outerMin" in selectObject || "outerMax" in selectObject) {
        let queryParam = {};
        if ("outerMin" in selectObject) {
          queryParam.gte = Number.parseFloat(
            selectObject.outerMin.replace(",", ".")
          );
        }
        if ("outerMax" in selectObject) {
          queryParam.lte = Number.parseFloat(
            selectObject.outerMax.replace(",", ".")
          );
        }

        queries.push({
          type: "range",
          field: "customFields.yuniqProductProperty_abm_gross_d",
          parameters: queryParam,
        });
      }

      if ("widthMin" in selectObject || "widthMax" in selectObject) {
        let queryParam = {};
        if ("widthMin" in selectObject) {
          queryParam.gte = Number.parseFloat(
            selectObject.widthMin.replace(",", ".")
          );
        }
        if ("widthMax" in selectObject) {
          queryParam.lte = Number.parseFloat(
            selectObject.widthMax.replace(",", ".")
          );
        }

        queries.push({
          type: "range",
          field: "customFields.yuniqProductProperty_virtuell_abm_hoehe",
          parameters: queryParam,
        });
      }

      if ("seal" in selectObject) {
        let sealQueries = [];

        selectObject["seal"].forEach( seal => {
          sealQueries.push({
            type: "equals",
            field: "customFields.yuniqProductProperty_dic_dichtung_alternativtext",
            value: seal
          })
        });

        queries.push({
          type: "multi",
          operator: "or",
          queries: sealQueries
        });
      }

      if ("categories" in selectObject) {
        let catQueries = [];

        selectObject["categories"].forEach( category => {
          catQueries.push({
            type: "equals",
            field: "customFields.yuniqProductProperty_gruppe_artikelgruppe",
            value: category
          })
        });

        queries.push({
          type: "multi",
          operator: "or",
          queries: catQueries
        });
      }

      if ("flange" in selectObject) {
        queries.push({
          type: "equals",
          field: "customFields.yuniqProductProperty_m_flansch",
          value: selectObject.flange,
        });
      }

      if ("rust" in selectObject) {
        queries.push({
          type: "equals",
          field: "customFields.yuniqProductProperty_rostfrei",
          value: selectObject.rust,
        });
      }

      filter.push({
        type: "multi",
        operator: "and",
        queries: queries,
      });

      instance
        .post("/product", {
          limit: this.bearingResultPageLength,
          page: selectObject.page,
          includes: {
            product: [
              "id",
              "name",
              "customFields.yuniqProductProperty_virtuell_innen_d",
              "customFields.yuniqProductProperty_abm_gross_d",
              "customFields.yuniqProductProperty_virtuell_abm_hoehe",
              "customFields.yuniqProductProperty_Anz_d_Reihen",
              "customFields.yuniqProductProperty_drw_klein_a",

              "customFields.yuniqProductProperty_m_flansch",
              "customFields.yuniqProductProperty_rostfrei",
              "customFields.yuniqProductProperty_dic_dichtung_alternativtext",
              "customFields.yuniqProductProperty_gruppe_artikelgruppe",

            ],
          },
          filter: filter,
          sort: [
            {
              field: selectObject.sortField,
              order: selectObject.sortDirection,
            }
          ],
          aggregations: aggregations,
        })
        .then((response) => {
          let data = response["data"];
          this.bearingResultList = data.elements;
          this.bearingResultListLength = data.aggregations.count.count;
          this.bearingResultCurrentPage = data.page;
          this.reloadingBearingList = false;
        })
        .catch((e) => {
          console.log("ERROR: ");
          console.log(e);
        });
    },
    closeBearingSelect: function () {
      this.bearingPickerIsOpen = false;
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap");

#app {
  font-family: Raleway, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.container {
  max-width: 1723px;
  margin: auto;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.box-grid {
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  align-items: center;
  justify-content: center;
}
h1,
h2 {
  color: $blueLight;
  font-size: 3.1875rem;
  font-weight: 300;
  margin-bottom: 2rem;
}
@media screen and (max-width: 26rem) {
  h1 {
    font-size: 1.75rem;
  }
}
h2 {
  font-size: 2.25rem;
  @media screen and (max-width: 26rem) {
    font-size: 1.5rem;
  }
}

.description {
  font-size: 20px;
  font-weight: 700;
}
.selectBox {
  max-width: 20rem;
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    font-weight: 22px;
  }
  button {
    margin-top: 2rem;
    transform: scale(1.25);
  }
}
.errorMessage {
  font-size: 1.25rem;
}
.spin-wrapper{
  display: flex;
}

.sbn-logo{
  height:5rem;
  margin-bottom:3rem;
  align-self:start;
  text-decoration:none;
  img{
    height:5rem;
  }
  span{
    display:block;
    text-align:left;
    margin-top:1.5rem;
    color:black;
    &:before{
      content:'<';
      padding-right:1rem;
    }
  }
}

</style>

